import {Form} from "../../form/form";
import {ObjectService} from "../../../js/object-service";
import {GvfService} from "../../../../gvf/js/gvf-service";

export class StatListTableWorkerForm extends Form{
    ready(){
        super.ready();
        this.$root.find("[data-controller-name=model-data-field]").each(
            (index,element) => {
                const $field = $(element);
                $field.find(".js-form-field-custom-object__add").unbind().click(
                    (ev)=>{
                        const service = new ObjectService("BaseModelDataField");
                        const items = $field.formFieldVal();
                        service.selectModelItem({fieldData:{multiple:true,tables:$field.data("tables")}}).then(
                            (ids)=>{
                                GvfService.endpoint("/cp/model-data-field/create-value-from-field-ids",{fieldIds:ids,tables:$field.data("tables"),ordering:!!$field.data("ordering")}).then(
                                    (response)=>{
                                        $field.formFieldSetVal((items?items:[]).concat(response.value));
                                    }
                                );
                            }
                        );
                    }
                );
            }
        );
    }
}

